import { render } from "./DelivryPersonsList.vue?vue&type=template&id=5501ef17&scoped=true"
import script from "./DelivryPersonsList.vue?vue&type=script&lang=js"
export * from "./DelivryPersonsList.vue?vue&type=script&lang=js"

import "./DelivryPersonsList.vue?vue&type=style&index=0&id=5501ef17&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5501ef17"]])

export default __exports__